import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay, Controller, EffectFade } from 'swiper/modules'
import Component from "../classes/Component"
import each from 'lodash/each'

export default class Hero extends Component {
    constructor({ element }) {
        super({ element })

        this.element.style.setProperty('--heading-hero-height', `${this.element.clientHeight}px`)
        this.createCarousel(this.element)
    }

    createCarousel = (entry) => {
        this.hero = new Swiper(entry, {
            modules: [Navigation, Pagination, Autoplay, Controller, EffectFade],
            slidesPerView: "1",
            centeredSlides: true,
            // effect: 'fade',
            loop: false,
            speed: 1000,
            navigation: {
                nextEl: this.element.querySelector("[data-next]"),
                prevEl: this.element.querySelector("[data-prev]"),
                clickable: true,
            },
            pagination: {
                type: "bullets",
                el: this.element.querySelector("[data-pagination-bullets]"),
                clickable: true,
                dynamicBullets: true,
            },
        })
        
        this.pagination = new Swiper(entry, {
            modules: [Pagination, Controller],
            pagination: {
                el: this.element.querySelector("[data-pagination-fraction]"),
                type: "fraction",
            },
        })
        
        this.hero.controller.control = this.pagination
    }

    addEventListeners() {
        window.addEventListener('resize', () => {
            this.element.style.setProperty('--heading-hero-height', `${this.element.querySelector('.headings-hero').clientHeight}px`)
        })
    }
}